import { ContentLayout } from '@nohara-dxdev/react-core';
import { AppendScopeItem, useApp } from '@nohara-dxdev/react-oidc';
import { useTranslation } from 'react-i18next';
import { useParams, Outlet, useRouteError } from 'react-router';

import { AppLayout } from '@/components/layouts';

import NotFoundRoute from '../not-found';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error(error);

  return (
    <AppLayout>
      <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>
    </AppLayout>
  );
};

const AppRoot = () => {
  const { appId } = useParams<{ appId: string }>();
  const { data: app, isLoading, isError } = useApp(appId);

  if (isError || (!isLoading && !app) || !appId) {
    return <NotFoundRoute />;
  }

  if (isLoading) {
    return (
      <AppLayout>
        <ContentLayout title="Loading...">Loading app...</ContentLayout>
      </AppLayout>
    );
  }

  return (
    <AppendScopeItem entity={app} type={'app'} id={appId}>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </AppendScopeItem>
  );
};

export default AppRoot;
